import { segmentMst } from '@libs/domain';
import { genMstColumns } from '@libs/templates/mst';
import type { Column } from '@ps-smart-cp/ppfw-client';
import type { SegmentMstRegistration } from '../models';

function genSegmentMstColumns(segmentMstKey: number): Column<SegmentMstRegistration>[] {
  return segmentMstKey > 1
    ? [
        ...genMstColumns<SegmentMstRegistration>(),
        {
          displayName: segmentMst.names.higherRankSegmentCode,
          renderCell: ({ row }) => row.higherRankSegmentCode,
        },
      ]
    : genMstColumns<SegmentMstRegistration>();
}

export { genSegmentMstColumns };
